<template>
  <div class="factureIntervenant" v-if="intervenant">
    <b-field class="columns is-marginless" v-if="afficherTitre">
      <div class="control column is-narrow is-paddingless" v-if="alignADroite">
        <button class="button is-primary" @click="reinitializeTitreIntervenant">
          <b-icon icon="autorenew"></b-icon>
        </button>
      </div>
      <b-input v-model="intervenant.titre"
               :class="{'has-text-right': alignADroite}"
               class="column is-paddingless mgb-10px"
               :placeholder="$t('editionFacture.clients.title')">
      </b-input>
      <div class="control column is-narrow is-paddingless" v-if="!alignADroite">
        <button class="button is-primary" @click="reinitializeTitreIntervenant">
          <b-icon icon="autorenew"></b-icon>
        </button>
      </div>
    </b-field>
    <div class="is-marginless is-paddingless section" :class="{ 'box' : afficherBox}">
      <a class="is-pulled-right" v-if="!alignADroite && !isSensAchat"
         @click="suppression()">
        <b-icon
          icon="delete-forever"
          type="is-danger">
        </b-icon>
      </a>
      <a class="is-pulled-right" v-if="!alignADroite && !isSensAchat"
         @click="changeDestinataire()">
        <b-icon class="article-float-fluid is-pulled-right" type='is-primary'
                icon="account-switch" v-if="!alignADroite">
        </b-icon>
      </a>
      <div class="columns is-multiline factureIntervenant-adresse is-vcentered" >
        <div v-if="alignADroite && intervenant.tiersId"
             class="column is-3-fullhd is-2-tablet has-text-right columns is-marginless">
          <div class="column is-paddingless"></div>
          <div class="column is-narrow is-paddingless">
            <b-tooltip :label="$t('editionFacture.clients.clientExonerationTva')"
                       v-if="intervenant.annonceur && func.getExonerationTva(intervenant)"
                       type="is-warning"
                       position="is-left">
              <b-icon icon="earth-arrow-right" class="is-cursor-pointer mgr-5px"
                      type="is-warning">
              </b-icon>
            </b-tooltip>
            <b-tooltip :label="$t('editionFacture.clients.prospect')"
                       v-if="intervenant.tiers.prospect"
                       type="is-warning"
                       position="is-left">
              <b-icon icon="account-search" class="is-cursor-pointer mgr-5px"
                      type="is-warning">
              </b-icon>
            </b-tooltip>
          </div>
          <router-link-blank
            icon="open-in-new"
            type="is-default"
            class="column is-narrow is-paddingless"
            :to="routeDetailIntervenant">
          </router-link-blank>
        </div>
        <div
          class="column is-9-fullhd is-10-tablet"
          :class="{'is-offset-3-fullhd is-offset-2-tablet': alignADroite && !intervenant.tiersId}">
          <b-autocomplete
            v-model="intervenant.nomCommercial"
            :data="dataClients"
            :open-on-focus="openOnFocus"
            field="nomCommercial"
            icon-right="magnify"
            @select="client => valideSelectionNomClient(client)"
            @input="getAsyncClientData"
            :loading="isFetching" >
            <template slot="header" v-if="!isSensAchat">
              <a @click="checkPermissions(constantes.TIERS.maj)
            ? isComponentAjoutClient = true : showPopUp()">
                <a class="lien"
                   :class="{'text-access-no-permission' : !checkPermissions(constantes.TIERS.maj)}">
                  <span> {{ $t('ajoutDevis.actions.addClient') }} </span>
                </a>
              </a>
            </template>
            <template slot-scope="props">
              {{ props.option.nomCommercialAvecVille }}
              <span
                v-if="!isSensAchat && props.option.blocageLevel === levelComptant
                  || props.option.blocageLevel === levelTotal">
                &nbsp;|&nbsp;
              </span>
              <span class="has-text-warning has-text-weight-bold"
                v-if="!isSensAchat && props.option.blocageLevel === levelComptant">
                {{ levelToString(props.option.blocageLevel) }}
              </span>
              <span class="has-text-danger has-text-weight-bold"
                v-if="!isSensAchat && props.option.blocageLevel === levelTotal">
                {{ levelToString(props.option.blocageLevel) }}
              </span>
            </template>
          </b-autocomplete>
        </div>
        <div v-if="!alignADroite" class="column is-3-fullhd is-1-tablet">
          <b-field>
            <router-link-blank
              v-if="intervenant.tiersId"
              icon="open-in-new"
              type="is-default"
              :to="routeDetailIntervenant">
            </router-link-blank>
            <b-tooltip :label="$t('editionFacture.clients.clientExonerationTva')"
                       v-if="intervenant.payeur && func.getExonerationTva(intervenant)"
                       type="is-warning"
                       position="is-right">
              <b-icon icon="earth-arrow-right" class="is-cursor-pointer mgl-5px"
                      type="is-warning">
              </b-icon>
            </b-tooltip>
            <b-tooltip :label="$t('editionFacture.clients.prospect')"
                       v-if="intervenant.tiers.prospect"
                       type="is-warning"
                       position="is-right">
              <b-icon icon="account-search" class="is-cursor-pointer mgl-5px"
                      type="is-warning">
              </b-icon>
            </b-tooltip>
          </b-field>
        </div>
        <b-input v-model="intervenant.adressePostale.intitule1"
                 class="column is-9-fullhd is-10-tablet "
                 v-if="intervenant.adressePostale.intitule1 && !isBonReception"
                 :class="{'is-offset-3-fullhd is-offset-2-tablet': alignADroite}">
        </b-input>
        <b-input v-model="intervenant.adressePostale.adresse1"
                 class="column is-9-fullhd is-10-tablet "
                 v-if="intervenant.adressePostale.adresse1 && !isBonReception"
                 :class="{'is-offset-3-fullhd is-offset-2-tablet': alignADroite}">
        </b-input>
        <b-input v-model="intervenant.adressePostale.adresse2"
                 class="column is-9-fullhd is-10-tablet "
                 v-if="intervenant.adressePostale.adresse2 && !isBonReception"
                 :class="{'is-offset-3-fullhd is-offset-2-tablet': alignADroite}">
        </b-input>
        <b-input v-model="intervenant.adressePostale.adresse3"
                 class="column is-9-fullhd is-10-tablet "
                 v-if="intervenant.adressePostale.adresse3 && !isBonReception"
                 :class="{'is-offset-3-fullhd is-offset-2-tablet': alignADroite}">
        </b-input>
        <div class="column is-3-fullhd is-1-tablet" v-if="!isBonReception && !alignADroite && (
        intervenant.adressePostale.adresse1 || intervenant.adressePostale.adresse2
        || intervenant.adressePostale.adresse3)">
        </div>
        <b-input v-model="intervenant.adressePostale.codePostal"
          class="column is-3-fullhd is-3-tablet"
          :class="{'is-offset-3-fullhd is-offset-2-tablet': alignADroite}"
          v-if=!isBonReception>
        </b-input>
        <b-autocomplete v-if="!isBonReception"
          class=""
          v-model="intervenant.adressePostale.ville"
          :data="villesAutocomplete"
          :loading="isFetchingVille"
          :open-on-focus="true"
          @typing="getVilles"
          @select="option => intervenant.adressePostale.ville = option">
        </b-autocomplete>
        <b-field
            v-if="intervenant.tvaIntracommunautaire"
            :label="$t('editionFacture.table.tvaIntracommunautaire')"
            class="column is-9-fullhd is-10-tablet"
            :class="{'is-offset-3-fullhd is-offset-2-tablet': alignADroite}">
          <p>
            {{ intervenant.tvaIntracommunautaire }}
          </p>
        </b-field>
        <b-field :label="$t('editionFacture.table.contact')"
            class="column is-9-fullhd is-10-tablet"
            :class="{
              'is-offset-3-fullhd is-offset-2-tablet': alignADroite,
              'column is-10-fullhd is-11-tablet': isBonReception
            }">
          <multi-contact-intervenant
            :isEdit="true"
            :intervenant="intervenant"/>
        </b-field>
        <div class="column is-12 colmuns is-multiline is-marginless editionFacture-informations"
             :class="{ 'has-text-right': alignADroite}" v-if="afficherRole">
          <b-checkbox v-model="intervenant.payeur" @input="payeur"
                      class="column is-narrow is-marginless">
            {{ $t('editionFacture.clients.payer')}}
          </b-checkbox>
          <b-checkbox v-model="intervenant.annonceur" @input="defineTitreIntervenant(intervenant)"
                      class="column is-narrow is-marginless">
            {{ $t('editionFacture.clients.advertiser')}}
          </b-checkbox>
          <b-checkbox v-model="intervenant.destinataireComptable" @input="destinataireComptable"
                      class="column is-narrow is-marginless">
            {{ $t('editionFacture.clients.accountingRecipient')}}
          </b-checkbox>
          <b-checkbox v-model="intervenant.mandataire" @input="defineTitreIntervenant(intervenant)"
                      class="column is-narrow is-marginless">
            {{ $t('editionFacture.clients.mandatary')}}
          </b-checkbox>
          <b-checkbox v-model="intervenant.donneurOrdre"
                      @input="defineTitreIntervenant(intervenant)"
                      class="column is-narrow is-marginless">
            {{ $t('editionFacture.clients.originator')}}
          </b-checkbox>
          <b-checkbox v-model="intervenant.destinataireEnCopie" v-if="!alignADroite"
                      class="column is-narrow is-marginless">
            {{ $t('editionFacture.clients.ccRecipient')}}
          </b-checkbox>
        </div>
      </div>
    </div>
    <b-modal v-model="isComponentAjoutClient"
             has-modal-card
             width="600px"
             class="modal factureIntervenant-addIntervenant">
      <creation-client @intervenant="updateIntervenant"
                       :place-intervenant="placeIntervenant"
                       :nouveauDevisCommande="facture"
                       :nomClient="intervenant.nomCommercial"/>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import majIntervenant from '@/services/devisCommandes/majIntervenant';
import * as intervenantNomCommercial from '@/services/facture/intervenantNomCommercial';
import { getAllAvecContact } from '@/api/tiers/index';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import defineTitreIntervenant from '@/services/devisCommandes/defineTitreIntervenant';
import * as tiersConf from '@/configuration/tiers/tiersConf';
import {
  SENS_ACHAT, SENS_VENTE,
  MODULE_ACHAT, TYPE_COMMANDE,
} from '@/configuration/devisConf';
import creationClient from '@/components/devisCommandes/editionDevisCommande/creationClient';
import { TIERS } from '@/configuration/permissionsBodacConf';
import getAllVilles from '@/services/ville/getAllVilles';
import { TIERS as TIERS_VILLE } from '@/configuration/ville/villeConf';
import messageErreur from '@/services/general/messageErreur';
import levelString from '@/services/tiers/levelToString';
import {
  LIMITE_AU_PAIEMENT_COMPTANT,
  TOTAL,
} from '@/configuration/tiers/levelBlocage';
import messageInformation from '@/services/general/messageInformation';
import multiContactIntervenant from '@/components/devisCommandeFacture/multicontact/multiContactIntervenant';
import cloneDeep from 'lodash/cloneDeep';
import { MODULE_TLPE } from '@/configuration/gabed/titreRecette/titreRecetteConf';
import getExonerationTva from '@/services/tiers/getExonerationTva';

const societe = createNamespacedHelpers('societe');
const Permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    alignADroite: {
      type: Boolean,
      required: true,
    },
    intervenant: {
      type: Object,
      rquired: true,
    },
    intervenantsFacture: {
      type: Array,
      required: true,
    },
    afficherRole: {
      type: Boolean,
      required: true,
    },
    afficherTitre: {
      type: Boolean,
      required: true,
    },
    afficherBox: {
      type: Boolean,
      required: true,
    },
    sens: {
      type: String,
      required: true,
    },
    facture: {
      type: Object,
      required: true,
    },
    placeIntervenant: {
      type: Number,
      required: false,
      default: 0,
    },
    sousTypes: {
      type: Array,
      required: false,
      default: () => [],
    },
    isBonReception: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      dataClients: [],
      isFetching: false,
      isFetchingVille: false,
      openOnFocus: false,
      isComponentAjoutClient: false,
      villesAutocomplete: [],
      constantes: {
        TIERS,
      },
      levelComptant: LIMITE_AU_PAIEMENT_COMPTANT,
      levelTotal: TOTAL,
      func: { getExonerationTva },
    };
  },
  components: {
    routerLinkBlank,
    creationClient,
    multiContactIntervenant,
  },
  computed: {
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    isSensAchat() {
      return this.sens === SENS_ACHAT;
    },
    isCommandeAchat() {
      return this.isSensAchat
        && this.facture.module === MODULE_ACHAT
        && this.facture.type === TYPE_COMMANDE;
    },
    routeDetailIntervenant() {
      if (!this.intervenant?.tiersId) return null;
      let routeName = this.isSensAchat ? 'c.baux.bailleur' : 'c.bodac.clients/contacts-client';
      if (this.facture.module === MODULE_TLPE) routeName = 'c.gabed.collectivite';
      const { tiers } = this.intervenant;
      if (this.isCommandeAchat) {
        routeName = tiers.type === tiersConf.TIERS_TYPE_FOURNISSEUR
          ? 'c.achat.fournisseurs' : 'c.bodac.clients/contacts-client';
      }
      return {
        name: routeName,
        params: { id: this.intervenant.tiersId },
      };
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    getVilles: debounce(async function getVilles(villeName) {
      try {
        this.isFetchingVille = true;
        this.villesAutocomplete = await getAllVilles(villeName, TIERS_VILLE);
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.isFetchingVille = false;
      }
    }, 300),
    destinataireComptable() {
      this.$emit('destinataireComptable', this.intervenant);
    },
    defineTitreIntervenant(intervenant) {
      defineTitreIntervenant(intervenant, this.$i18n);
      this.$emit('updateModeCalculHonoraire');
    },
    payeur() {
      if (this.intervenant.payeur) {
        this.$emit('payeur', this.intervenant);
      }
      this.defineTitreIntervenant(this.intervenant);
    },
    suppression() {
      this.$emit('suppression', this.intervenant);
      this.$emit('updateModeCalculHonoraire');
    },
    changeDestinataire() {
      this.$emit('changeDestinataire', this.intervenant);
    },
    getSousTypes() {
      if (this.sousTypes.length > 0) {
        return this.sousTypes;
      }
      let result = [];
      if (this.sens !== SENS_ACHAT) {
        result = [tiersConf.TIERS_SOUS_TYPE_AUCUN];
      } else if (this.facture.module === MODULE_TLPE) {
        result = [tiersConf.TIERS_SOUS_TYPE_COLLECTIVITE];
      } else {
        result = [
          tiersConf.TIERS_SOUS_TYPE_BAILLEUR_PRIVE,
          tiersConf.TIERS_SOUS_TYPE_BAILLEUR_CONCESSION,
          tiersConf.TIERS_SOUS_TYPE_BAILLEUR_PRO,
          tiersConf.TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE,
        ];
      }
      return result;
    },
    reinitializeTitreIntervenant() {
      this.intervenant.titre = null;
      defineTitreIntervenant(this.intervenant, this.$i18n);
    },
    getAsyncClientData: debounce(function ClientData() {
      if (!this.intervenant.nomCommercial) {
        this.intervenant.tiersId = null;
        this.intervenant.contactId = null;
        return;
      }
      this.dataClients = [];
      this.isFetching = true;
      const sousTypes = this.getSousTypes();
      getAllAvecContact(
        this.intervenant.nomCommercial,
        this.societeActiveId,
        this.sens === SENS_ACHAT ? tiersConf.TIERS_TYPE_FOURNISSEUR : tiersConf.TIERS_TYPE_CLIENT,
        sousTypes,
      ).then((response) => {
        response.data.result.items.forEach((client) => {
          if (client.archive || client.prospect) {
            return;
          }
          if (client.id !== this.intervenant.tiersId) {
            const clientPresent = this.intervenantsFacture.find((intervenantFacture) => {
              return intervenantFacture.tiersId === client.id;
            }) != null;
            if (clientPresent) {
              return;
            }
          }
          const regex = new RegExp(this.intervenant.nomCommercial.trim(), 'gi');

          if ((client.nomCommercial.match(regex)
            || client.compteComptable.match(regex))
            && !client.archive) {
            intervenantNomCommercial.initialiseClientAutoComplete(client);
            this.dataClients.push(client);
          }
          client.contacts.forEach((contact) => {
            if (contact.archive) {
              return;
            }
            const clientContact = intervenantNomCommercial.initialiseContactAutoComplete(contact,
              client);
            if (clientContact.nomCommercialAvecVille.match(regex)) {
              contact.client = cloneDeep(client);
              this.dataClients.push(clientContact);
            }
          });
        });
        this.isFetching = false;
      }).catch(() => {
        this.isFetching = false;
      });
    }, 500),
    updateIntervenant(intervenant) {
      majIntervenant(this.intervenant, intervenant);
      this.$emit('addCommentaireFacturationOfIntervenant', intervenant.commentairesFacturation);
      this.$emit('updateModeCalculHonoraire');
    },
    valideSelectionNomClient(item) {
      if (!item) {
        return;
      }
      if (item.blocageLevel === this.levelTotal) {
        messageInformation(this.$i18n.t('detailClient.popupBlocage.unselectable',
          { nomCommercial: item.nomCommercial }), 'is-danger');
        return;
      }
      intervenantNomCommercial.nomCommercialePourIntervenant(item);
      majIntervenant(this.intervenant, item);
      if (this.sens === SENS_VENTE
        && !this.intervenantsFacture.some(inter => inter.annonceur)) {
        this.intervenant.annonceur = true;
      }
      if (this.sens === SENS_ACHAT) {
        this.intervenant.destinataireComptable = true;
        this.intervenant.payeur = true;
        this.$emit('updateCompteComptableAndModePaiement');
      }
      if (this.isCommandeAchat) {
        this.intervenant.annonceur = true;
        this.intervenant.destinataire = true;
        this.intervenant.destinataireComptable = false;
        this.intervenant.repartition = 100;
      }
      this.$emit('addCommentaireFacturationOfIntervenant', item.commentairesFacturation);
      this.$emit('updateModeCalculHonoraire');
    },
    levelToString(blocageLevel) {
      return levelString(this.$i18n, blocageLevel);
    },
  },
};
</script>
<style lang="scss">

</style>
